const deleteSubscriber = axios => {
  return axios.delete('subscribers');
};

const exportSubscriber = (axios, email) => {
  return axios.post('subscribers/export', { email });
};

export { deleteSubscriber, exportSubscriber };
